<template>
    <v-select
        v-model="value"
        cache-items
        dense
        outlined
        hide-details
        :small-chips="smallChips"
        :deletable-chips="deletableChips"
        :hide-selected="multiple"
        :items="itemsList"
        :search-input.sync="searchItem"
        open-on-clear
        item-value="ZonaId"
        item-text="Nombre"
        no-data-text="Elige una zona"
        :label="label"
        :readonly="readonly"
        return-object
        ref="ZonaFindCtrl"
        :multiple="multiple"
        :clearable="!readonly"
        :menu-props="{ 'open-on-click': true, offsetY: true }"
        @click="clickEvt"
        @input="inputEvt"
        @change="changeEvt"
        @blur="blurEvt"
    ></v-select>
</template>

<script>
  import axios from "axios";
  import { mapState } from "vuex";
  export default {
    computed:{
        ...mapState(['urlRaiz', 'empId'])
    },
    data: () => ({
      itemsList: [],
      searchItem: null
    }),
    props: ['value', 'label', 'multiple', 'readonly', 'smallChips', 'deletableChips'],
    methods: {
      loadItems() {
        var controllerParameters = {
          EmpId: this.empId
          // Searcher: true
        };

        var AuthToken = localStorage.getItem('token');  
        axios({ method: "POST", "url": this.urlRaiz + "/api/zona/list", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } }).then(result => {
          this.itemsList = [];
          result.data.EntsList.forEach(element => {
            var itemObject = { 
              ZonaId: element.ZonaId, 
              Nombre: element.Nombre
            };
            this.itemsList.push(itemObject);
          });
        });
      },
      clickEvt() {
        this.$emit('click');
      },
      inputEvt() {
        this.$emit('input', this.value);
      },
      changeEvt() {
        this.$emit('change', this.value);
      },
      blurEvt() {
        this.$emit('blur', this.value);
      }
    },
    mounted() {
        this.itemsList = [];
        this.loadItems();
    },
  }
</script>